import { Link } from "react-router-dom";

const shipped = [
  {
    slug: "viewshift",
    name: "ViewShift",
    url: "https://viewshift.io",
    tagline: "YouTube, uncomplicated.",
    description:
      "An AI-powered search that ranks YouTube by relevance, not views. A live demonstration of the AI-led workflow redesign thinking we bring to client work.",
    image: "/viewshift-preview.jpg",
    status: "Live",
  },
];

export default function Shipped() {
  return (
    <section
      id="shipped"
      data-testid="shipped-section"
      className="relative px-6 md:px-12 py-24 md:py-32 border-b border-rule bg-paper"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-3">
            <div className="overline text-slate reveal">What we have built</div>
            <div className="mono text-xs text-slate mt-3 reveal">— 06</div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="shipped-heading"
              className="serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight leading-[1.05] text-ink reveal"
            >
              Operating thinking, applied in the open.
            </h2>
          </div>
        </div>

        {shipped.map((p) => (
          <ShippedRow key={p.slug} p={p} />
        ))}
      </div>
    </section>
  );
}

function ShippedRow({ p }) {
  return (
    <article
      data-testid={`shipped-${p.slug}`}
      className="grid grid-cols-12 gap-6 md:gap-10 border-t border-rule pt-12 md:pt-14"
    >
      <div className="col-span-12 lg:col-span-5 reveal">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-1.5 h-1.5 bg-brass" />
          <span className="overline text-ink">{p.status}</span>
        </div>

        <h3 className="serif text-3xl md:text-4xl lg:text-5xl font-light leading-tight tracking-tight text-ink">
          {p.name}
        </h3>
        <p className="mt-3 text-base md:text-lg text-slate">{p.tagline}</p>

        <p className="mt-6 text-sm md:text-base leading-relaxed text-ink/80 max-w-lg">
          {p.description}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center">
          <Link
            to={`/built/${p.slug}`}
            data-testid={`shipped-readmore-${p.slug}`}
            className="group inline-flex items-center gap-2 bg-ink text-paper px-6 py-3 text-sm hover:bg-mustard hover:text-ink transition-colors duration-300"
          >
            Read how it was built
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
          <a
            href={p.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`shipped-visit-${p.slug}`}
            className="group inline-flex items-center gap-2 text-sm text-ink hover:text-brass transition-colors duration-300 px-2 py-3"
          >
            <span className="link-line">Visit live</span>
            <span aria-hidden>↗</span>
          </a>
        </div>
      </div>

      <div className="col-span-12 lg:col-span-7 reveal">
        <a
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block group"
          aria-label={`Open ${p.name}`}
        >
          <div className="border border-rule bg-white shadow-[0_24px_50px_-30px_rgba(0,0,0,0.2)] transition-transform duration-700 group-hover:-translate-y-0.5">
            <div className="border-b border-rule px-4 py-2.5 flex items-center gap-2 bg-paper">
              <span className="w-2.5 h-2.5 rounded-full bg-rule" />
              <span className="w-2.5 h-2.5 rounded-full bg-rule" />
              <span className="w-2.5 h-2.5 rounded-full bg-rule" />
              <span className="ml-3 mono text-[11px] text-slate truncate">viewshift.io</span>
            </div>
            <img
              src={p.image}
              alt={`${p.name} preview`}
              loading="lazy"
              className="w-full h-auto block"
              data-testid={`shipped-image-${p.slug}`}
            />
          </div>
        </a>
      </div>
    </article>
  );
}
